import { getTotalHierarcyKey, ROLES ,ACTIVE_USERS,PUBLIC_DATA, DATA_ASSETS,BEHAVIORMODEL, POLICY, OPEN_ANOMALIES, LOCATION, COUNTRY, DATASOURCE, ACTIVITIES, USERS, ANOMALIES, ASSETS } from './ActionTypes';

/**
 * Popup configuration constants
 * Define different popup types and their template configurations
 */

export const POPUP_TEMPLATES = {
  SPLIT_LAYOUT: 'SPLIT_LAYOUT',
  TABLE_TOP_CHART: 'TABLE_TOP_CHART'
};

/**
 * Configuration map for different popup cases
 * Add new popup configurations here to easily manage all 10 popup types
 */
export const POPUP_CONFIGURATIONS = {
  // Current implementation - Location/Country/DataSource popup
  [getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, ACTIVITIES])]: {
    template: POPUP_TEMPLATES.SPLIT_LAYOUT,
    title: "Location - Activities",
    subHeading: "Activities:",
    showCountryFlag: true,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, USERS])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Location - Users",
    subHeading: "Users:",
    showCountryFlag: true,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, ANOMALIES])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Location - Anomalies",
    subHeading: "Anomalies:",
    sideChart: true,
    showCountryFlag: true,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, ASSETS])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Location - Assets",
    subHeading: "Assets:",
    showCountryFlag: true,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, USERS])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Behavior Model - Users",
    subHeading: "Users:",
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, ANOMALIES])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Behavior Model - Total Anomalies",
    subHeading: "Anomalies:",
    sideChart: true,
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, OPEN_ANOMALIES])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Behavior Model - Open Anomalies",
    subHeading: "Anomalies:",
    sideChart: true,
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, DATA_ASSETS])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Public Data - Data Assets",
    subHeading: "Assets:",
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, ACTIVITIES])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Public Data - Activities",
    subHeading: "Activities:",
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, COUNTRY])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "Public Data - Country",
    subHeading: "Assets:",
    showCountryFlag: true,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([ROLES, DATASOURCE, USERS])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "User Roles - Users",
    subHeading: "Users:",
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([ROLES, DATASOURCE, ACTIVE_USERS])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "User Roles - Active Users",
    subHeading: "Users:",
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([ROLES, DATASOURCE, ANOMALIES])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "User Roles - Anomalies",
    subHeading: "Anomalies:",
    sideChart: true,
    showCountryFlag: false,
    sideChartTitle: "Locations"
  },
  [getTotalHierarcyKey([ROLES, DATASOURCE, COUNTRY])]: {
    template: POPUP_TEMPLATES.TABLE_TOP_CHART,
    title: "User Roles - Country",
    subHeading: "Activities:",
    showCountryFlag: true,
    sideChartTitle: "Locations"
  }
};

/**
 * Get popup configuration by category
 */
export const getPopupConfig = (category) => {
  return POPUP_CONFIGURATIONS[category] || {
    template: POPUP_TEMPLATES.SPLIT_LAYOUT,
    title: "Default Title",
    subHeading: "Items:",
    showCountryFlag: false,
    sideChartTitle: "Data"
  };
};